:host {
}

.stzh-share {
  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }

  &__item {
    &:not(:last-child) {
      margin-right: space("xxsmall");
    }
  }
}
